import { render, staticRenderFns } from "./DashboardContainer.vue?vue&type=template&id=61025851&scoped=true"
import script from "./DashboardContainer.vue?vue&type=script&lang=js"
export * from "./DashboardContainer.vue?vue&type=script&lang=js"
import style0 from "./DashboardContainer.vue?vue&type=style&index=0&id=61025851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61025851",
  null
  
)

export default component.exports